import { useEffect, useState } from 'react'

/** false в первом HTML, true после монтирования в браузере */
export const useClientReady = (): boolean => {
  const [ready, setReady] = useState(false)

  useEffect(() => {
    setReady(true)
  }, [])

  return ready
}
